import {UrlMatchResult, UrlSegment} from '@angular/router';

export function listWithDetailParamMatcher(url: UrlSegment[], data: {listRoute: string, singleRoute: string, paramName: string}): UrlMatchResult | null {
  if (url.length === 0) {
    return {consumed: []};
  } else if (url.length === 1 && url[0].path === data.listRoute) {
    return {
      consumed: url
    };
  } else if (url.length === 2 && url[0].path === data.singleRoute) {
    return {
      consumed: url,
      posParams: {
        [data.paramName]: url[1]
      }
    };
  }
  return null;
}

